import React, { useState } from 'react';
import { DxContainer, DxToggle, DxIcon, DxText, DxButton } from '@dvag/design-system-react';
import { checkIcon } from 'utils/util';
import i18next from 'i18next';
import '../../style.css';
import { FundsModal } from 'component/FundsModal/FundsModal';

export const FundsSection = ({
  enabled,
  onToggle,
}: {
  enabled: boolean;
  onToggle: (checked: boolean) => void;
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <DxContainer color="transparent" className="settings-section">
        <DxIcon
          icon={checkIcon('investment')}
          size={24}
          className="settings-section-icon"
          color="primary"
        />
        <DxContainer color="transparent" className="settings-section-content">
          <DxText type="Infotext-Small" color="gray-66">
            {i18next.t('vpDigitalSettings.funds.fundToolSmall')}
          </DxText>
          <DxText type="Paragraph-Standard" className="settings-inline-text">
            {i18next.t('vpDigitalSettings.funds.customFundSelection')}
          </DxText>
          <DxText type="Infotext-Small" color="gray-66" className="settings-block-text">
            {i18next.t('vpDigitalSettings.funds.description')}
          </DxText>
        </DxContainer>
        <DxToggle
          checked={enabled}
          onCheckedChange={(e) => onToggle(e.detail)}
          data-testid="funds-toggle"
        />
      </DxContainer>

      {enabled && (
        <DxContainer style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 8px' }}>
          <DxButton
            data-testid="funds-edit-button"
            type="secondary-s"
            label={i18next.t('fundsModal.title')}
            onClick={handleOpenModal}
          />
        </DxContainer>
      )}

      {isModalVisible && <FundsModal visible={isModalVisible} onClose={handleCloseModal} />}
    </>
  );
};
